import { lazy, Suspense } from 'react';
import Spin from 'components/Spin';
import type { IBrandConfig } from './types';

const MissGroupSafeTermsOfService = lazy(
  () => import('pages/terms-of-service/miss-group-safe'),
);

const DSHOP_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: { kind: 'cms', path: 'policy/dshop-policy.md' },
  termsOfService: {
    kind: 'component',
    render: () => (
      <Suspense fallback={<Spin />}>
        <MissGroupSafeTermsOfService />
      </Suspense>
    ),
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'domene_shop',
  adaChat: false,
  accountDetails: true,
  personalInformation: false,
  secureUpload: false,
  billingDetails: false,
  offersAndUpgrades: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'Domeneshop',
  hasCustomerServiceSupport: false,
  ssoRedirectURL: null,
  carouselBanners: false,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [
      {
        title: 'Domene:',
        href: 'https://domene.shop/contact',
        icon: 'support-faq',
        customerSupport: true,
      },
    ],
    call: {},
    email: {
      active: false,
    },
  },
};

export default DSHOP_BRAND_CONFIG;
